export const isStore = (location: string) => !!location.match(/T[0-9]{4}/)
export const isRegion = (location: string) => !!location.match(/R[0-9]{3}/)
export const isGroup = (location: string) => !!location.match(/G[0-9]{3}/)
export const isDistrict = (location: string) => !!location.match(/D[0-9]{3}/)
export const isRGD = (location: string) =>
    isRegion(location) || isGroup(location) || isDistrict(location)
export const isStoreOrRGD = (location: string) =>
    isStore(location) || isRGD(location)
export const isCompany = (location: string) =>
    location === 'Company Target' || location === 'Company'
